import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, Fragment as _Fragment, createBlock as _createBlock } from "vue"
import _imports_0 from '@/assets/images/download-play-store.svg'


const _hoisted_1 = { class: "landing" }
const _hoisted_2 = { class: "landing__content" }
const _hoisted_3 = {
  key: 0,
  class: "landing-header__title"
}
const _hoisted_4 = { class: "landing-main" }
const _hoisted_5 = { class: "landing-car-image" }
const _hoisted_6 = ["srcset"]
const _hoisted_7 = ["src"]
const _hoisted_8 = { class: "landing-main__title" }
const _hoisted_9 = { class: "text text-center" }
const _hoisted_10 = ["href"]
const _hoisted_11 = ["src"]
const _hoisted_12 = {
  key: 1,
  class: "landing-main__store-btn",
  src: _imports_0,
  alt: ""
}
const _hoisted_13 = { class: "landing__button-container" }

import LanguagePicker from "@/components/ui/LanguagePicker.vue"
import ConfirmModal from "@/components/ui/ConfirmModal.vue"
import config from "../config/index"
import { isAndroid, isIOS, isMobile } from "mobile-device-detect"
import PageHeader from "../components/ui/PageHeader.vue"
import ButtonComponent from "../components/ui/ButtonComponent.vue"
import appleStoreImageHu from "@/assets/logos/apple_store_badge_web_generic_hu.svg"
import appleStoreImageEn from "@/assets/logos/apple_store_badge_web_generic_en.svg"
import ChargingPrices from "../components/ui/ChargingPrices.vue"
import LoadingComponent from "../components/ui/LoadingComponent.vue"
import { computed, ref } from "vue"
import { useI18n } from "vue-i18n"
import { useRouter } from "vue-router"
import { useUserStore } from "../store/user"
import { storeToRefs } from "pinia"
import { useDictionaryStore } from "../store/dictionary"


export default /*@__PURE__*/_defineComponent({
  __name: 'LandingPage',
  setup(__props) {

const { setSeenLandingPage } = useUserStore()
const dictionaryStore = useDictionaryStore()
const { dynamicConfig } = storeToRefs(dictionaryStore)
const router = useRouter()
const { locale } = useI18n()

const isConfirmModalActive = ref(false)
const clickedNext = ref(false)

const appDownloadLink = computed(() => {
  if (isIOS) {
    return config.links.app_ios
  }
  if (isAndroid) {
    return config.links.app_android
  }
  return ""
})

const appleStoreImage = computed(() => {
  return locale.value === "hu" ? appleStoreImageHu : appleStoreImageEn
})

const confirmNext = () => {
  isConfirmModalActive.value = false
  setSeenLandingPage(true)
  router.push("terms")
}

const next = () => {
  if (
    (config.links.app_ios.length > 0 || config.links.app_android.length > 0) &&
    isMobile
  ) {
    clickedNext.value = true
  } else {
    confirmNext()
  }
}

const nextInsteadOfDownload = () => {
  isConfirmModalActive.value = true
}

const handleNextButtonClick = () => {
  if (clickedNext.value) {
    nextInsteadOfDownload()
  } else {
    next()
  }
}

const navigateToAppDownload = () => {
  window.location.href = appDownloadLink.value
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(PageHeader, { "header-class": 'header--landing' }, {
        default: _withCtx(() => [
          (!clickedNext.value)
            ? (_openBlock(), _createElementBlock("h1", _hoisted_3, [
                _createTextVNode(_toDisplayString(_ctx.$t("landingPage.greetings.title")) + " ", 1),
                _cache[0] || (_cache[0] = _createElementVNode("br", null, null, -1)),
                _createTextVNode(" " + _toDisplayString(_ctx.$t("landingPage.greetings.subTitle")), 1)
              ]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }),
      _createElementVNode("main", _hoisted_4, [
        _createElementVNode("picture", _hoisted_5, [
          _createElementVNode("source", {
            srcset: `${_unref(config).imagesPath}/main-image-light.png`,
            media: "(prefers-color-scheme: dark)"
          }, null, 8, _hoisted_6),
          _createElementVNode("img", {
            src: `${_unref(config).imagesPath}/main-image.png`,
            alt: ""
          }, null, 8, _hoisted_7)
        ]),
        (clickedNext.value)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createElementVNode("h1", _hoisted_8, [
                _createTextVNode(_toDisplayString(_ctx.$t("landingPage.greetings.title")) + " ", 1),
                _cache[1] || (_cache[1] = _createElementVNode("br", null, null, -1)),
                _createTextVNode(" " + _toDisplayString(_ctx.$t("landingPage.greetings.subTitle")), 1)
              ]),
              _createElementVNode("p", _hoisted_9, _toDisplayString(_ctx.$t("landingPage.greetings.shouldUseApp")), 1),
              (_unref(isMobile))
                ? (_openBlock(), _createElementBlock("a", {
                    key: 0,
                    class: "block",
                    href: appDownloadLink.value
                  }, [
                    (_unref(isIOS))
                      ? (_openBlock(), _createElementBlock("img", {
                          key: 0,
                          class: "landing-main__store-btn",
                          src: appleStoreImage.value,
                          alt: ""
                        }, null, 8, _hoisted_11))
                      : _createCommentVNode("", true),
                    (_unref(isAndroid))
                      ? (_openBlock(), _createElementBlock("img", _hoisted_12))
                      : _createCommentVNode("", true)
                  ], 8, _hoisted_10))
                : _createCommentVNode("", true)
            ], 64))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              (!_unref(dynamicConfig))
                ? (_openBlock(), _createBlock(LoadingComponent, { key: 0 }))
                : _createCommentVNode("", true),
              (_unref(dynamicConfig) && _unref(dynamicConfig).isPriceInfoVisible)
                ? (_openBlock(), _createBlock(ChargingPrices, {
                    key: 1,
                    class: "landing__charging-prices",
                    "ac-charger-base-of-calculation": 
              _unref(dynamicConfig).acChargerBaseOfCalculation
            ,
                    "ac-charger-price": _unref(dynamicConfig).acChargerPrice,
                    currency: _unref(dynamicConfig).currency,
                    "dc-charger-base-of-calculation": 
              _unref(dynamicConfig).dcChargerBaseOfCalculation
            ,
                    "dc-charger-price": _unref(dynamicConfig).dcChargerPrice,
                    "prepay-amount": _unref(dynamicConfig).prepayAmount,
                    "rapid-charger-base-of-calculation": 
              _unref(dynamicConfig).rapidChargerBaseOfCalculation
            ,
                    "rapid-charger-price": _unref(dynamicConfig).rapidChargerPrice,
                    "valid-from": _unref(dynamicConfig).validFrom,
                    "hide-registration-charge": 
              _unref(config).featureGuestChargingIsComissionBased
            ,
                    "guest-commission": _unref(dynamicConfig).guestCommission,
                    "registration-charge": _unref(dynamicConfig).registrationCharge
                  }, null, 8, ["ac-charger-base-of-calculation", "ac-charger-price", "currency", "dc-charger-base-of-calculation", "dc-charger-price", "prepay-amount", "rapid-charger-base-of-calculation", "rapid-charger-price", "valid-from", "hide-registration-charge", "guest-commission", "registration-charge"]))
                : _createCommentVNode("", true),
              _createVNode(LanguagePicker)
            ], 64))
      ])
    ]),
    _createElementVNode("div", _hoisted_13, [
      _createVNode(ButtonComponent, {
        block: "",
        primary: "",
        onClick: handleNextButtonClick
      }, {
        default: _withCtx(() => [
          (!clickedNext.value)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createTextVNode(_toDisplayString(_ctx.$t("landingPage.next")), 1)
              ], 64))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _createTextVNode(_toDisplayString(_ctx.$t("landingPage.nextInsteadOfDownload")), 1)
              ], 64))
        ]),
        _: 1
      })
    ]),
    (isConfirmModalActive.value)
      ? (_openBlock(), _createBlock(ConfirmModal, {
          key: 0,
          "yes-button-color-class": "btn-download",
          "main-title": _ctx.$t('landingPage.confirm.appDownload.mainTitle'),
          "sub-title": _ctx.$t('landingPage.confirm.appDownload.subTitle'),
          "yes-title": _ctx.$t('landingPage.confirm.appDownload.yesTitle'),
          "no-title": _ctx.$t('landingPage.confirm.appDownload.noTitle'),
          onConfirm: confirmNext,
          onCancel: navigateToAppDownload
        }, null, 8, ["main-title", "sub-title", "yes-title", "no-title"]))
      : _createCommentVNode("", true)
  ]))
}
}

})